import React from "react";
import { useLocalStorage } from '@rehooks/local-storage';
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
    const [deviceKey] = useLocalStorage('dk'); 
	return deviceKey ? <Outlet /> : <Navigate to="/login"  replace />;
};

export default ProtectedRoutes;